import Select, { components } from "react-select";
import React from "react";
import { SelectStyles } from "app/routes/Calendar/EventForm/constants";
import { useTranslation } from "react-i18next";

interface OptionProps {
  value: string | number;
  label: string;
}

interface SelectBoxProps {
  options: OptionProps[];
  value: OptionProps | null;
  setValue: any;
  noOptionsText?: string;
  ariaLabel?: string | null;
  containerStyle?: string | null;
  customControl?: any;
  customColor?: string;
  customWidth?: string;
  isDisabled?: boolean;
  'data-testid'?: string;
  isSearchable?: boolean;
  hideDropdownIndicator?: boolean;
  placeholder?: string;
}

const SelectBox = ({
  options,
  value,
  setValue,
  noOptionsText,
  ariaLabel = null,
  containerStyle = null,
  customColor = null,
  customWidth = "",
  isDisabled = false,
  'data-testid': testId,
  isSearchable = true,
  hideDropdownIndicator = false,
  placeholder,
}: SelectBoxProps) => {
  const { t } = useTranslation();

  const customOptions = {
    ...SelectStyles,
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    control: (base, state) => ({
      ...SelectStyles.control(base, state),
      borderColor: state.isFocused ? '#039be5' : (customColor || '#E7E7E7'),
      width: customWidth,
      borderRadius: "8px",
    }),
    valueContainer: (baseStyles) => ({
      ...baseStyles,
      height: 42,
      color: '#000',
      overflow: 'visible',
    }),
  };
  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        <span>{noOptionsText || t("No options")}</span>
      </components.NoOptionsMessage>
    );
  };

  const CustomMenu = (props) => {
    return (
      <div className="time-range-menu-dropdown">
        <components.Menu {...props}>
          {props.children}
        </components.Menu>
      </div>
    );
  };

  return (
    <div className={`${containerStyle}`} data-testid={testId}>
      <Select
        isDisabled={isDisabled}
        isSearchable={isSearchable}
        menuPortalTarget={document.body}
        placeholder={placeholder || t("Select")}
        styles={customOptions}
        value={value}
        onChange={setValue}
        aria-label={ariaLabel}
        components={{
          IndicatorSeparator: () => null,
          ...(hideDropdownIndicator ? { DropdownIndicator: () => null } : {}),
          NoOptionsMessage,
          Menu: CustomMenu,
        }}
        options={options}
        menuPlacement="auto"
      />
    </div>
  );
};

export default SelectBox;
